// extracted by mini-css-extract-plugin
export var wrapper = "SliderButton-module--wrapper--c76ae";
export var arrowIcon = "SliderButton-module--arrowIcon--d8cc9";
export var white = "SliderButton-module--white--27f3c";